import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-6xl md:text-8xl font-heading font-bold text-foreground-200 mb-4">404</h1>
          <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
          <p className="text-sm text-foreground-500 mb-8">你访问的页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}